import React from "react";
import { Toast } from "antd-mobile";
import { setToast, Popup, verifyHOC } from "@al/security-verification-foundation";
export { IpVerifyResult, SEV_BIZ_TYPE_KEY, SEV_IP_VALIDATE_STATUS_KEY, SEV_OPERATION_ID_KEY } from "@al/security-verification-foundation";
var securityVerificationMobile_vanilla = "";
setToast(Toast);
class SecurityVerificationImpl extends React.Component {
  constructor() {
    super(...arguments);
    this.setShowBack = (showBack) => {
      var _a, _b;
      (_b = (_a = this.props).setShowBack) == null ? void 0 : _b.call(_a, showBack);
    };
  }
  render() {
    const { visible } = this.props;
    return /* @__PURE__ */ React.createElement(Popup, {
      visible,
      bodyClassName: this.props.className,
      destroyOnClose: true,
      afterClose: this.props.onCloseModal
    }, this.props.children);
  }
}
var index = verifyHOC({ platform: "mobile" })(SecurityVerificationImpl);
export { index as default };
